import { Tag } from "antd";
import type { Category } from "@/lib/types";
import { CATEGORY_LABELS } from "@/lib/constants";
import { categoryColors } from "@/theme/tokens";

/** Tag colorida por categoria (cores colhidas de references/src/index.css). */
export const CategoryTag: React.FC<{ value?: Category | null }> = ({ value }) => {
  if (!value) return <Tag>—</Tag>;
  return (
    <Tag color={categoryColors[value]} style={{ borderRadius: 8 }}>
      {CATEGORY_LABELS[value] ?? value}
    </Tag>
  );
};
